// extracted by mini-css-extract-plugin
export default {"statsGrid":"StatsGrid_statsGrid__FvCDY","statItem":"StatsGrid_statItem__WBfUH","statNumber":"StatsGrid_statNumber__GzM+Q","statLabel":"StatsGrid_statLabel__GEuWZ"};